import { FC } from "react";

import Loader from "@shared-containers/Loader";
import { Flex } from "@shared-ui-components/Flex";

import { NotificationEmptyStateCard } from "../../Notification/NotificationList/NotificationEmptyState/style";
import SingleCheckEmptyState from "./SingleCheckEmptyState";
import { CheckInformationWrapper, MainCard } from "./style";

interface CheckType {
  singleCheckData: JSX.Element[][];
  loading: boolean;
}

const Check: FC<CheckType> = ({ singleCheckData, loading }) => {
  if (loading) {
    return (
      <NotificationEmptyStateCard>
        <Loader />
      </NotificationEmptyStateCard>
    );
  }
  if (singleCheckData?.length) {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {singleCheckData?.map((e: JSX.Element[]) => (
          <CheckInformationWrapper>
            <Flex justifyContent="flex-start" alignItems="center">
              <MainCard>
                <pre>{e}</pre>
              </MainCard>
            </Flex>
          </CheckInformationWrapper>
        ))}
      </>
    );
  }

  return <SingleCheckEmptyState />;
};

export default Check;
